(() => {
class DDAssetLogosFocus extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-dd-carousel-track]');
    if (!this.track) return;

    this.abortController = new AbortController();
    const { signal } = this.abortController;

    this.addEventListener('focusin', (event) => this.revealFocusedItem(event.target), { signal });
    this.addEventListener('focusout', () => window.setTimeout(() => this.syncFocusReveal(), 0), { signal });
    window.addEventListener('resize', () => this.resetFocusReveal(), { signal });
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.resetFocusReveal();
  }

  get isStaticWideBleed() {
    return (
      window.matchMedia('(min-width: 990px)').matches &&
      this.track.classList.contains('dd-asset-logos__track--grid') &&
      this.track.classList.contains('dd-asset-logos__track--desktop-6') &&
      !this.track.classList.contains('dd-asset-logos__track--desktop-overflow')
    );
  }

  get currentShift() {
    const shift = Number.parseFloat(this.track.style.getPropertyValue('--dd-asset-logos-focus-shift'));
    return Number.isFinite(shift) ? shift : 0;
  }

  syncFocusReveal() {
    const activeItem = document.activeElement?.closest?.('[data-dd-carousel-item]');
    if (activeItem && this.contains(activeItem)) this.revealFocusedItem(activeItem);
    else this.resetFocusReveal();
  }

  revealFocusedItem(target) {
    const item = target?.closest?.('[data-dd-carousel-item]');
    if (!item || !this.contains(item) || !this.isStaticWideBleed) {
      this.resetFocusReveal();
      return;
    }

    const surface = this.closest('.dd-asset-logos')?.querySelector('.dd-section-shell__surface');
    if (!surface) return;

    const shift = this.currentShift;
    const itemRect = item.getBoundingClientRect();
    const surfaceRect = surface.getBoundingClientRect();
    const visibleLeft = Math.max(0, surfaceRect.left);
    const visibleRight = Math.min(document.documentElement.clientWidth, surfaceRect.right);
    const naturalLeft = itemRect.left - shift;
    const naturalRight = itemRect.right - shift;
    let nextShift = 0;

    if (naturalRight > visibleRight) nextShift = visibleRight - naturalRight;
    else if (naturalLeft < visibleLeft) nextShift = Math.min(0, visibleLeft - naturalLeft);

    this.track.style.setProperty('--dd-asset-logos-focus-shift', `${nextShift}px`);
    this.track.toggleAttribute('data-dd-focus-revealed', Math.abs(nextShift) > 0.5);
    if (document.scrollingElement?.scrollLeft) document.scrollingElement.scrollLeft = 0;
  }

  resetFocusReveal() {
    if (!this.track) return;
    this.track.style.removeProperty('--dd-asset-logos-focus-shift');
    this.track.removeAttribute('data-dd-focus-revealed');
  }
}

if (!customElements.get('dd-asset-logos-focus')) {
  customElements.define('dd-asset-logos-focus', DDAssetLogosFocus);
}
})();
